import React from "react";
import { WEDDING } from "../utils/config";

export default function ProposalVideo() {
  const isUnlocked = new Date() >= new Date(WEDDING.videoUnlockDate);

  return (
    <section
      style={{
        background: "var(--cream)",
        padding: "96px 36px",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "720px", margin: "0 auto" }} className="reveal">
        <div
          className="section-tag"
          style={{ justifyContent: "center", display: "flex" }}
        >
          A Special Moment
        </div>
        <h2 className="section-title">
          The <em>Proposal</em> Video
        </h2>

        {!isUnlocked ? (
          /* ── LOCKED ── */
          <div
            style={{
              border: ".5px solid var(--sage-p)",
              borderRadius: "12px",
              padding: "60px 36px",
              marginTop: "36px",
              background: "linear-gradient(135deg,var(--mint-p),var(--sage-p))",
              position: "relative",
              overflow: "hidden",
              boxShadow:
                "0 16px 48px rgba(36,60,40,.1), 0 2px 0 rgba(255,255,255,.6) inset",
            }}
          >
            {[180, 260, 340].map((s, i) => (
              <div
                key={i}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  width: `${s}px`,
                  height: `${s}px`,
                  border: `0.5px solid rgba(107,155,111,${0.1 - i * 0.03})`,
                  borderRadius: "50%",
                  pointerEvents: "none",
                }}
              />
            ))}

            <div
              style={{
                fontSize: "44px",
                marginBottom: "18px",
                position: "relative",
                zIndex: 1,
              }}
            >
              🔒
            </div>

            <div
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "26px",
                color: "var(--deep)",
                marginBottom: "10px",
                position: "relative",
                zIndex: 1,
              }}
            >
              This video is a surprise
            </div>

            <p
              style={{
                fontSize: "13px",
                color: "var(--muted)",
                lineHeight: 1.85,
                maxWidth: "360px",
                margin: "0 auto",
                position: "relative",
                zIndex: 1,
              }}
            >
              Our proposal video is a cherished private moment. It unlocks
              automatically on the date set below — visible to all guests from
              that moment onwards.
            </p>

            <div
              style={{
                marginTop: "20px",
                display: "inline-block",
                padding: "8px 24px",
                background: "var(--deep)",
                color: "var(--gold)",
                fontSize: "9px",
                letterSpacing: ".2em",
                textTransform: "uppercase",
                borderRadius: "20px",
                position: "relative",
                zIndex: 1,
              }}
            >
              Unlocks · {formatDate(WEDDING.videoUnlockDate)}
            </div>

            <UnlockCountdown unlockDate={WEDDING.videoUnlockDate} />
          </div>
        ) : (
          /* ── UNLOCKED ── */
          <div style={{ marginTop: "36px" }}>
            <div
              style={{
                position: "relative",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#000",
                aspectRatio: "9/16",
                maxWidth: "405px",
                margin: "0 auto",
                boxShadow: "0 24px 64px rgba(0,0,0,.4)",
              }}
            >
              <iframe
                src="/videos/proposal.mp4"
                title="Proposal video"
                style={{ width: "100%", height: "100%", border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            <p
              style={{
                marginTop: "13px",
                fontSize: "10px",
                color: "var(--sage)",
                letterSpacing: ".09em",
              }}
            >
              🔓 Viewing enabled
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

function formatDate(dateStr) {
  try {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
}

function UnlockCountdown({ unlockDate }) {
  const [timeLeft, setTimeLeft] = React.useState(getTimeLeft(unlockDate));

  React.useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft(unlockDate)), 1000);
    return () => clearInterval(id);
  }, [unlockDate]);

  if (!timeLeft) return null;

  return (
    <div
      style={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        position: "relative",
        zIndex: 1,
      }}
    >
      {[
        ["Days", timeLeft.d],
        ["Hours", timeLeft.h],
        ["Mins", timeLeft.m],
        ["Secs", timeLeft.s],
      ].map(([unit, val]) => (
        <div key={unit} style={{ textAlign: "center" }}>
          <div
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "28px",
              fontWeight: 300,
              color: "var(--sage-d)",
              lineHeight: 1,
            }}
          >
            {val}
          </div>
          <div
            style={{
              fontSize: "8px",
              letterSpacing: ".16em",
              textTransform: "uppercase",
              color: "var(--muted)",
              marginTop: "3px",
            }}
          >
            {unit}
          </div>
        </div>
      ))}
    </div>
  );
}

function getTimeLeft(dateStr) {
  const diff = new Date(dateStr) - new Date();
  if (diff <= 0) return null;
  return {
    d: String(Math.floor(diff / 86400000)).padStart(2, "0"),
    h: String(Math.floor((diff % 86400000) / 3600000)).padStart(2, "0"),
    m: String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0"),
    s: String(Math.floor((diff % 60000) / 1000)).padStart(2, "0"),
  };
}
